import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Light } from 'themes';
import themeable from 'zignal-landscape/lib/themeable';
import MfeHeader from '../../components/MfeHeader/MfeHeader';
import HomeCard from './components/HomeCard';
import GetHelp from './components/GetHelp/GetHelp';
import HelpSearch from './components/HelpSearch/HelpSearch';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';

import {
  getQuickLinks
} from './homePageHelper';

class HomePage extends Component {
  componentDidMount() {
    // Clean up page-specific CSS from previous pages (React 18 and later may not call componentWillUnmount)
    window.$('#main-content').removeClass('bot-intelligence-page discover-page mfe-page');
    window.$('body').css('background-color', '#A0A6AE');
    window.$('html').removeClass('influence-intelligence-y-scroll');
    window.$('.powered-by').css('display', 'initial');
  }

  render () {
    const {
      styles,
      dashboards,
      reports,
      alerts,
      isRestrictedUser
    } = this.props;

    const quickLinks = getQuickLinks(dashboards, reports, alerts, isRestrictedUser);

    const HomeCardsSection = ({ items }) => {
      return (
        <div className={styles.HomeCard}>
          {items.map((item, i) => (<HomeCard key={i} cardProps={item} />))}
        </div>
      );
    };


    return (
      <ThemeProvider theme={Light}>
        <MfeHeader title="Welcome to Zignal" />
        <div className={styles.HomePage}>
          <div className={styles.HomePageInner}>
            <div id="home-news-pendo" />
            <div id="quickLinks">
              <HomeCardsSection items={quickLinks} />
            </div>
            <div className={styles.HomePageHelp}>
              <div className={styles.HomePageSearchInput}>
                <HelpSearch />
              </div>
              <div className={styles.HomePageGetHelp}>
                <GetHelp />
              </div>
            </div>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

HomePage.propTypes = {
  styles: PropTypes.object,
  dashboards: PropTypes.array,
  reports: PropTypes.array,
  alerts: PropTypes.array,
};


export default themeable(HomePage);
